import * as React from 'react'
import { useEffect } from "react"

import RadioElements from './RadioElements'

const getIdAlertTp = alert => {
    const data = {
        'competition': () => {
            return [5, 6]
        },
        'parity-ota': () => {
            return [2, 4]
        },
        'parity-meta': () => {
            return [1, 3]
        },
        'packages': () => {
            return [7, 8]
        },
        'info': () => {
            return [9]
        }
    }

    return data[alert]()
}

export default function RadioMultiButton(props) {

    const { title='', items, value, onChange, changeAlertType, disabled } = props

    useEffect(() => {
        changeAlertType({ value: getIdAlertTp(value)[0] })
    // eslint-disable-next-line
    }, [value])

    return <div className="switch-field switch-table-prices flex flex-middle flex-end">
        <div className="switch-title">{title}</div>
        { items.map((item, id) => {
            return <RadioElements item={item} key={id} id={id} onChange={onChange} value={value} disabled={disabled} />
        }) }
    </div>
}